import { render, staticRenderFns } from "./CardPassword.vue?vue&type=template&id=2bb9c4d2&"
import script from "./CardPassword.vue?vue&type=script&lang=js&"
export * from "./CardPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports